import { AuthFeatures } from "./enums/AuthFeatures";
import { AuthFeatureResources } from "./enums/AuthFeatureResources";
export { AuthFeatures, AuthFeatureResources };
export const UNLIMITED_LOT_AREA_LIMIT_M2 = -1;
export var Rules;
(function (Rules) {
    Rules["Read"] = "read";
    Rules["Write"] = "write";
})(Rules || (Rules = {}));
export var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus["ENABLED"] = "ENABLED";
    FeatureStatus["DISABLED"] = "DISABLED";
    FeatureStatus["HIDDEN"] = "HIDDEN";
    FeatureStatus["UNKNOWN"] = "UNKNOWN";
})(FeatureStatus || (FeatureStatus = {}));
